import { createAction } from '@reduxjs/toolkit';
import { studentRegistrationTypes } from 'types';

export const STUDENT_REGISTRATION_SAGA = 'STUDENT_REGISTRATION_SAGA';
export const studentRegistrationSaga = createAction<studentRegistrationTypes.IStudentRegistrationForm>(
    STUDENT_REGISTRATION_SAGA
);
